module.exports = __webpack_public_path__ + "static/media/oppo-indonesia-1.911428af.jpg";